$(function() {
	$(window).on('load resize', function() {
		if (window.matchMedia('(min-width: 769px)').matches) {
			$('#header .nav__item-id-shop').mouseover(function() {
				$('#header').addClass('kiki-active');
			})
			$('#header').mouseout(function() {
				$('#header').removeClass('kiki-active');
			});
		} else {}
                  
 	});
    $('.product__description .c-comment__winery').clone(true).appendTo('.product__image-container');

	$('#mobile-nav').on('click', function(event) {
		$('#header').toggleClass('kiki-nav-active');
	});

	$('.quick-search__trigger').on('click', function(event) {
		$('.search').fadeToggle('400');
		$('.search__overlay').fadeToggle('400');
	});
	$('.search__input-close').on('click', function(event) {
		$('.search').fadeOut('400');
		$('.search__overlay').fadeOut('400');
	});
	$('.search__overlay').on('click', function(event) {
		$('.search').fadeOut('400');
		$('.search__overlay').fadeOut('400');
	});
  
  
    
});
